import { appConstants } from "../_constants";
import axios from "axios";
import moment from "moment/moment";

export const appHelpers = {
  formatDate: d => {
    return (d) ? moment((d).split('T')[0]).format('MMM DD, YYYY') : '';
  },
  formatDateSpecific: (d, format) => {
    return moment(d).format(format || 'MMM DD, YYYY');
  },
  interpretCurrency: c => {
    let currency;
    switch (c) {
      case 566:
        currency = 'NGN'; break;
      case 840:
        currency = 'USD'; break;
      default:
        currency = 'NGN';
    }
    return currency;
  },
  downloadFile: function (fileUrl, fileName) {
    // get file extension
    let fileExtension = fileUrl.split(".").pop();

    let xhr = new XMLHttpRequest();
    xhr.open("GET", fileUrl);
    xhr.responseType = "blob";

    let that = this;
    xhr.onload = function () {
        that.saveFile(this.response, fileExtension, fileName)
    };
    xhr.send();
},
  saveFile: (blob, fileExtension, fileName) => {
    let anchor = document.createElement("a");
    document.body.appendChild(anchor);
    anchor.style = 'display: none';

    let url = window.URL.createObjectURL(blob);
    anchor.href = url;
    anchor.download = `${fileName}.${fileExtension}`;
    anchor.click();
    window.URL.revokeObjectURL(url);
  },
  interpretEntityTypeId: id => {
    let entity;
    switch (id) {
      case 1:
        entity = 'Create Airline'; break;
      case 2:
        entity = 'Update Airline'; break;
      case 3:
        entity = 'Create Airport'; break;
      case 4:
        entity = 'Update Airport'; break;
      case 5:
        entity = 'Create Flight'; break;
      case 6:
        entity = 'Update Flight'; break;
      case 7:
        entity = 'Match Payment'; break;
      case 8:
        entity = 'Create FTP Credential'; break;
      case 9:
        entity = 'Delete FTP Credential'; break;
      case 10:
        entity = 'Upload Payment'; break;
      case 11:
        entity = 'Create Workflow'; break;
      case 12:
        entity = 'Update Workflow'; break;
      case 13:
        entity = 'Create Flag Metrics Location'; break;
      case 14:
        entity = 'Create Airline Location'; break;
      case 15:
        entity = 'Update Airline Location'; break;
      case 16:
        entity = 'Create Ticket Class'; break;
      case 17:
        entity = 'Update Ticket Class'; break;
        case 18:
          entity = 'Create Airline Wallet'; break;
      default:
        entity = 'Unknown';
    }
    return entity;
  },
  getCurrencyUnicode: c => {
    let currency;
    switch (c) {
      case 566:
        currency = 0x20A6; break;
      case 840:
        currency = 0x0024; break;
      default:
        currency = 0x20A6;
    }
    return currency;
  },
  postRequest: function (url, payload, header) {
    let reqHeader = header
      ? header
      : { "Content-Type": "application/json", AppName: appConstants.APP_ID };
    let config = { headers: reqHeader };

    return axios.post(url, payload, config);
  },
  postBinaryRequest: function (url, payload, header) {
    let reqHeader = header
      ? header
      : { "Content-Type": "application/json", AppName: appConstants.APP_ID };
    let config = { headers: reqHeader, responseType: 'blob' };

    return axios.post(url, payload, config);
  },
  postRequestBIllPerAirport: function (url, payload, header) {
    let user = JSON.parse(localStorage.getItem('avi-user'));
    let reqHeader = header
      ? header
      : { "Content-Type": "application/json", AppName: appConstants.APP_ID, 'Authorization': `Bearer ${user.access_token}` };
    let config = { headers: reqHeader };

    return axios.post(url, payload, config);
  },
  spriteEmailRequest: function (url, payload, header) {
    let reqHeader = header
      ? header
      : { "Content-Type": "application/json", AppName: appConstants.APP_ID };
    let config = { headers: reqHeader };

    return axios.post(url, payload, config);
  },
  getRequest: function (url, header) {
    let reqHeader = header
      ? header
      : { "Content-Type": "application/json", AppName: appConstants.APP_ID };
    let config = { headers: reqHeader };
    // console.log(config);
    // return axios
    //   .get(url, config)
    //   .then(function(res) {
    //     return res;
    //   })
    //   .catch(function(err) {
    // console.log(err);
    // });
    return axios.get(url, config)
  },
  getBinaryRequest: function (url, header) {
    let reqHeader = header
      ? header
      : { "Content-Type": "application/json", AppName: appConstants.APP_ID };
    let config = { headers: reqHeader, responseType: 'blob' };
    // console.log(config);
    // return axios
    //   .get(url, config)
    //   .then(function(res) {
    //     return res;
    //   })
    //   .catch(function(err) {
    // console.log(err);
    // });
    return axios.get(url, config)
  },
  postFormDataRequest: function (url, formData, header) {
    let reqHeader = header
      ? header
      : { "Content-Type": "multipart/form-data", AppName: appConstants.APP_ID };
    let config = { headers: reqHeader };

    return axios.post(url, formData, config);
  },
  formatResponse: function (res) {
    return res.data;
  },
  formatPromiseResponse: function (res, resType) {
    let responseType =
      resType === undefined ? appConstants.SUCCESS_RESPONSE : resType;
    return { status: responseType, response: res };
  },
  interpretErrorResponse(error) {
    let errorMessage = "";
    if (error.response) {
      errorMessage = error.response.data
        ? error.response.data
        : "Unable to handle request";
    } else if (error.request) {
      errorMessage = "Currently, unable to handle request!"
    } else {
      errorMessage = "Something went wrong!"
    }


    
    /*if (error.response === undefined) {
      errorMessage = "Please check your internet connectivity!";
    } else {
      errorMessage = error.response.data
        ? error.response.data
        : "Unable to handle request";
    }*/
    if (typeof errorMessage === "string") {
      return errorMessage;
    }
    else if (Array.isArray(errorMessage)) {
      return errorMessage.join(',');
    } else if (typeof error === "object") {
      return error.response.data.Message;
    }
    else {
      return "Something went wrong right now!";
    }
  },
  interpretErrorResponseAlt2(error) {
    let errorMessage = "";
    if (error.response) {
      errorMessage = (error.response.data) ? error.response.data.ErrorMessages : 'Unable to handle request';
    } else if (error.request) {
      errorMessage = "Currently, unable to handle request!"
    } else {
      errorMessage = "Something went wrong!"
    }

    // if (error.response === undefined) {
    //   errorMessage = "Please check your internet connectivity!";
    // } else {
    //     errorMessage = (error.response.data) ? error.response.data.ErrorMessages : 'Unable to handle request';
    // }
    if (typeof errorMessage === "string") {
      return errorMessage;
    }
    else if (Array.isArray(errorMessage)) {
      return errorMessage.join(',');
    } else if (typeof error === "object") {
      return error.response.data.Message || error.response.data;
    }
    else {
      return "Something went wrong!";
    }
  },
  getActiveUser: function () {
    let __usr__ = localStorage.getItem(appConstants.AVI_USER_KEY);
    return __usr__ ? JSON.parse(__usr__) : false;
  },
  interpretRole: function (activeUser) {
    if (activeUser.userRole === appConstants.ROLES.ADMIN) {
      if (activeUser.AirlineCode === null) {
        return appConstants.ROLES.ADMIN;
      } else {
        return appConstants.ROLES.AIRLINE_ADMIN;
      }
    }
    else if (activeUser.userRole === appConstants.ROLES.STAFF) {
      if (activeUser.AirlineCode === null) {
        return appConstants.ROLES.STAFF;
      } else {
        return appConstants.ROLES.AIRLINE_STAFF;
      }
    }
    else if (activeUser.userRole === appConstants.ROLES.VGG_SUPERADMIN) {
      return appConstants.ROLES.VGG_SUPERADMIN
    }
    else if (activeUser.userRole === appConstants.ROLES.VGG_ADMIN) {
      return appConstants.ROLES.VGG_ADMIN
    }
    else if (activeUser.userRole === appConstants.ROLES.VGG_USER) {
      return appConstants.ROLES.VGG_USER
    }

    else {
      return activeUser.userRole;
    }
  },
  checkPageAuthorization: function (role, page) {
    switch (role) {
      case appConstants.ROLES.SUPER_ADMIN:
        return 1;
      case appConstants.ROLES.ADMIN:
        return 1;
        // return appConstants.ROLES_PAGES.ADMIN.indexOf(page);
      case appConstants.ROLES.NCAA_DATR:
        return 1;
        // return appConstants.ROLES_PAGES.NCAA_DATR.indexOf(page);
      case appConstants.ROLES.AIRLINE_ADMIN:
        return appConstants.ROLES_PAGES.AIRLINE_ADMIN.indexOf(page);
      case appConstants.ROLES.BSP_ADMIN:
        return 1;
        // return appConstants.ROLES_PAGES.BSP_ADMIN.indexOf(page);
      case appConstants.ROLES.STAFF:
        return appConstants.ROLES_PAGES.STAFF.indexOf(page);
      case appConstants.ROLES.AIRLINE_STAFF:
        return appConstants.ROLES_PAGES.AIRLINE_STAFF.indexOf(page);
      case appConstants.ROLES.VGG_SUPERADMIN:
        return 1;
        // return appConstants.ROLES_PAGES.VGG_SUPERADMIN.indexOf(page);
      case appConstants.ROLES.VGG_ADMIN:
        return 1;
      case appConstants.ROLES.VGG_USER:
        // return appConstants.ROLES_PAGES.VGG_USER.indexOf(page);
        return 1;
      default:
        return -1;
    }
  },
  isAuthorised: function () {
    const activeUser = appHelpers.getActiveUser();
    const { AviRole } = activeUser;
    const queryString = window.location.href.split('/');
    const queryLength = queryString.length;
    const page_url = (queryLength > 4) ? queryString[queryLength - 2] : queryString[queryLength - 1];
    if (AviRole) {
      if (this.checkPageAuthorization(AviRole, page_url) > -1) {
        return true;
      } else {
        this.setSessionErrorMessage(appConstants.AVI_USER_SESSION_UNAUTHORISED_ERROR_MESSAGE);
        return false;
      }
    } else {
      this.setSessionErrorMessage(appConstants.AVI_USER_SESSION_AUTHENTICATION_REQUIRED_MESSAGE);
      return false;
    }
  },
  setSessionErrorMessage: function (value) {
    localStorage.setItem(appConstants.AVI_USER_SESSION_ERROR, value);
  },
  getSessionErrorMessage: function () {
    return localStorage.getItem(appConstants.AVI_USER_SESSION_ERROR);
  },
  destroySessionExpired: function () {
    if (localStorage.getItem(appConstants.AVI_USER_SESSION_EXPIRED))
      localStorage.removeItem(appConstants.AVI_USER_SESSION_EXPIRED);
    if (localStorage.getItem(appConstants.AVI_USER_SESSION_ERROR))
      localStorage.removeItem(appConstants.AVI_USER_SESSION_ERROR);
  },
  destroySession: function () {
    let __usr__ = localStorage.getItem(appConstants.AVI_USER_KEY);
    if (__usr__) localStorage.removeItem(appConstants.AVI_USER_KEY);
  },
  numberWithCommas: x => {
    x = x.toFixed(2);
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  },
  numberWithCommasOnly: x => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  },
  numbersWithCommas: x => {
    if(x.length < 2){
      return x;
    }
    x = x.toFixed(2);
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  },

  isEqual: (value, other) => {
    // Get the value type
    var type = Object.prototype.toString.call(value);

    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false;

    // If items are not an object or array, return false
    if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false;

    // Compare the length of the length of the two items
    var valueLen =
      type === "[object Array]" ? value.length : Object.keys(value).length;
    var otherLen =
      type === "[object Array]" ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    // Compare two items
    var compare = function (item1, item2) {
      // Get the object type
      var itemType = Object.prototype.toString.call(item1);

      // If an object or array, compare recursively
      if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
        if (!appHelpers.isEqual(item1, item2)) return false;
      } else {
        // Otherwise, do a simple comparison
        // If the two items are not the same type, return false
        if (itemType !== Object.prototype.toString.call(item2)) return false;

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (itemType === "[object Function]") {
          if (item1.toString() !== item2.toString()) return false;
        } else {
          if (item1 !== item2) return false;
        }
      }
    };

    // Compare properties
    if (type === "[object Array]") {
      for (var i = 0; i < valueLen; i++) {
        if (compare(value[i], other[i]) === false) return false;
      }
    } else {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          if (compare(value[key], other[key]) === false) return false;
        }
      }
    }

    // If nothing failed, return true
    return true;
  },
  interpretAirline:(airlineId, airlines)=> {
    const { Results } = airlines;
    if (Results) {
      const airlineName = Results.find(airline => airline.Id === airlineId);
      if (airlineName) return airlineName.Name;
    }
  },
  findAllByKey: function (obj, keyToFind) {
    if (obj) {
      return Object.entries(obj).reduce(
        (acc, [key, value]) =>
          key === keyToFind
            ? acc.concat(value)
            : typeof value === "object"
            ? acc.concat(appHelpers.findAllByKey(value, keyToFind))
            : acc,
        []
      );
    }
  },  

  downloadFileV2: function (fileData, fileName, isBase64 = false, mimeType = "application/pdf") {
    if (isBase64) {
    this.downloadFromBase64(fileData, fileName, mimeType);
  } else {
    this.downloadFromFilestream(fileData, fileName, mimeType);
  }
},
// Handle base64 data
  downloadFromBase64: function (base64Data, fileName, mimeType) {
  const base64String = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  
  const blob = new Blob([bytes], { type: mimeType});
  this.triggerDownload(blob, fileName, mimeType);
},
// Handle filestream/blob data
downloadFromFilestream: function (fileData, fileName, mimeType) { 
  try {
    const blob = fileData instanceof Blob ? fileData : new Blob([fileData], { type: mimeType });
     
    this.triggerDownload(blob, fileName, mimeType);
  } catch (error) {
    console.error("Error in downloadFromFilestream:", error);
  }
},
// Trigger the download
triggerDownload: function (blob, fileName, mimeType) {   
  try {

    let extension = "bin";
    switch (mimeType) {
      case "application/pdf":
        extension = "pdf";
        break;
      case "application/vnd.ms-excel":
        extension = "xls"; 
        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        extension = "xlsx"; 
        break;
      case "text/csv":
        extension = "csv";
        break;
    }
    const url = window.URL.createObjectURL(blob);
     
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.${extension}`;
    
     
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
   } catch (error) {
    console.error("Error in triggerDownload:", error);
  }
},

getMimeTypeFromType: function (typeId) {
  switch (typeId) {
    case 1: // Excel
      return "application/vnd.ms-excel"; 
      // or "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      // depending on what backend really sends
    case 2: // PDF
      return "application/pdf";
    default:
      return "application/octet-stream";
  }
}


};






// WEBPACK FOOTER //
// ./src/_helpers/app.helpers.js